import axios from 'axios';
import { getApiUrl } from '../../../config';

export function requestServiceAccounts() {
    return axios.request({
        method: 'get',
        url: `${getApiUrl()}/service-account`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestCreateServiceAccount(data) {
    return axios.request({
        method: 'post',
        url: `${getApiUrl()}/service-account`,
        withCredentials: true,
        crossorigin: true,
        data,
    });
}

export function requestRotateServiceAccount(id) {
    return axios.request({
        method: 'post',
        url: `${getApiUrl()}/service-account/${id}/rotate`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestActivateServiceAccount(id) {
    return axios.request({
        method: 'put',
        url: `${getApiUrl()}/service-account/${id}/activate`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestDeactivateServiceAccount(id) {
    return axios.request({
        method: 'put',
        url: `${getApiUrl()}/service-account/${id}/deactivate`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestDeleteServiceAccount(id) {
    return axios.request({
        method: 'delete',
        url: `${getApiUrl()}/service-account/${id}`,
        withCredentials: true,
        crossorigin: true,
    });
}
